import type React from 'react'

interface InfluencersIconProps {
  size?: number | string
  color?: string
  className?: string
}

const InfluencersIcon: React.FC<InfluencersIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Influencers Icon'}
      role="img"
    >
      <path
        d="M9.00113 1.25C11.8651 1.25023 14.1906 3.57636 14.1906 6.44043V6.44336C14.1788 9.24364 11.9714 11.5255 9.1857 11.6191C9.15246 11.6202 9.11919 11.6195 9.08609 11.6162C9.03787 11.6114 8.96578 11.6111 8.89859 11.6172C8.86776 11.62 8.83677 11.6202 8.80582 11.6191C6.02075 11.5255 3.81093 9.24361 3.8107 6.44043C3.8107 3.57732 6.12582 1.25 9.00113 1.25ZM5.3107 6.44043C5.31093 8.43248 6.87439 10.0461 8.84293 10.1191C8.94234 10.1133 9.0454 10.1134 9.14469 10.1191C11.1134 10.0481 12.6804 8.43529 12.6906 6.44043L12.6857 6.25C12.5866 4.30243 10.973 2.75023 9.00113 2.75C6.95645 2.75 5.3107 4.40354 5.3107 6.44043Z"
        fill={color}
      />
      <path
        d="M9.17285 12.4375C11.1002 12.4375 13.0657 12.9215 14.585 13.9355C15.9515 14.8447 16.7353 16.1194 16.7354 17.4912C16.7354 18.7769 16.048 19.9795 14.8369 20.8779L14.5879 21.0537C13.0638 22.0735 11.095 22.5595 9.16602 22.5596C7.23693 22.5596 5.26738 22.0735 3.74316 21.0537C2.37807 20.1447 1.59581 18.87 1.5957 17.499C1.5957 16.1277 2.37789 14.8505 3.74316 13.9365L3.74609 13.9346C5.27443 12.9212 7.24455 12.4376 9.17285 12.4375ZM9.17285 13.9375C7.47141 13.9376 5.80668 14.369 4.5752 15.1855C3.52269 15.8912 3.0957 16.7435 3.0957 17.499C3.0958 18.2074 3.4709 18.9993 4.38574 19.6729L4.57617 19.8057L4.57812 19.8066C5.80389 20.6267 7.46521 21.0596 9.16602 21.0596C10.8668 21.0595 12.5282 20.6268 13.7539 19.8066C14.8083 19.1007 15.2354 18.2473 15.2354 17.4912C15.2353 16.7355 14.8083 15.8854 13.7549 15.1846L13.7539 15.1836C12.5335 14.3686 10.8746 13.9375 9.17285 13.9375Z"
        fill={color}
      />
      <g opacity="0.4">
        <path
          d="M19.1609 7.5C19.1609 5.98282 17.9353 4.75 16.4109 4.75C15.9967 4.74994 15.6609 4.41417 15.6609 4C15.6609 3.58583 15.9967 3.25006 16.4109 3.25C18.7665 3.25 20.6609 5.15718 20.6609 7.5C20.6609 9.79544 18.8399 11.664 16.5691 11.749C16.5287 11.7505 16.4882 11.7492 16.448 11.7441C16.4331 11.7423 16.4025 11.7409 16.364 11.7451C15.9524 11.7909 15.5818 11.4946 15.5359 11.083C15.4902 10.6714 15.7864 10.3007 16.198 10.2549C16.3059 10.2429 16.4184 10.242 16.53 10.249C17.9912 10.1853 19.1609 8.97878 19.1609 7.5Z"
          fill={color}
        />
        <path
          d="M17.6399 13.835C17.731 13.431 18.1323 13.1775 18.5363 13.2686C19.3243 13.4462 20.0974 13.7629 20.7502 14.2598C21.6929 14.9668 22.2209 15.9532 22.2209 16.9951C22.2209 18.037 21.6938 19.0235 20.7512 19.7305L20.7502 19.7295C20.0896 20.2348 19.3051 20.5654 18.4943 20.7344C18.0889 20.8188 17.6913 20.5586 17.6066 20.1533C17.5222 19.7479 17.7824 19.3502 18.1877 19.2656C18.8139 19.1352 19.3861 18.8866 19.844 18.5352L19.8508 18.5303C20.4681 18.0673 20.7209 17.5031 20.7209 16.9951C20.7209 16.4871 20.4681 15.9229 19.8508 15.46L19.8459 15.4561C19.4 15.1156 18.8358 14.8733 18.2063 14.7314C17.8022 14.6404 17.5488 14.239 17.6399 13.835Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default InfluencersIcon
